// extracted by mini-css-extract-plugin
module.exports = {"loading":"pay-sdk-status-view__loading___nEjuz","error":"pay-sdk-status-view__error___3qKMD"};